module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-12.4efd66b6.mp3";